export const APP_NAME_SHORT = 'TSX';
export const APP_NAME = 'tsx-ui';
